import React from 'react';
import { X, PlusCircle } from 'lucide-react';

function AddProductModal({ show, onClose, newItem, setNewItem, handleAddProduct, loading }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-slate-950/80 backdrop-blur-md z-[130] flex items-center justify-center p-6">
      <div className="bg-slate-900 rounded-[40px] w-full max-w-lg p-10 shadow-2xl border border-blue-500/20 relative scale-in">
        <button onClick={onClose} className="absolute top-6 right-6 p-2 text-slate-500 hover:text-rose-500 transition"><X size={32}/></button>
        <div className="mb-8">
          <h3 className="text-2xl font-black text-white flex items-center gap-3"><PlusCircle className="text-blue-400"/> Yangi Tovar</h3>
        </div>

        <div className="space-y-6">
          <input type="text" className="w-full p-5 bg-slate-950 border border-white/5 rounded-[25px] outline-none font-mono text-xs text-white" placeholder="Markirovka Kodi..." value={newItem.marking_code} onChange={e => setNewItem({...newItem, marking_code: e.target.value})} />
          <input type="text" className="w-full p-5 bg-slate-950 border border-white/5 rounded-[25px] outline-none font-bold text-white" placeholder="Mahsulot Nomi..." value={newItem.product_name} onChange={e => setNewItem({...newItem, product_name: e.target.value})} />
          <div className="grid grid-cols-2 gap-4">
            <input type="number" className="w-full p-5 bg-slate-950 border border-white/5 rounded-[25px] outline-none font-black text-white" placeholder="Tannarx" value={newItem.cost_price} onChange={e => setNewItem({...newItem, cost_price: e.target.value})} />
            <select className="w-full p-5 bg-slate-950 border border-white/5 rounded-[25px] outline-none font-bold text-white" value={newItem.unit} onChange={e => setNewItem({...newItem, unit: e.target.value})}>
              <option value="dona">dona</option>
              <option value="kg">kg</option>
            </select>
          </div>
          <button onClick={handleAddProduct} disabled={loading} className="w-full bg-blue-600 text-white py-6 rounded-[30px] font-black hover:bg-blue-700 transition disabled:opacity-50 uppercase tracking-widest mt-4">
            {loading ? "SAQLANMOQDA..." : "OMBORGA QO'SHISH"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddProductModal;
